/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Writes_LabelInputs */



/**
* | output |
* | --- |
* | "Allow unattended irreversible actions" |
*
* @param {Agent_Policy_Destructive_Writes_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_writes_label = /** @type {((inputs?: Agent_Policy_Destructive_Writes_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Writes_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Unbeaufsichtigte unumkehrbare Aktionen erlauben")
	return /** @type {LocalizedString} */ ("Allow unattended irreversible actions")
});